import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSy = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h900v600H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h900v400H0z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h900v200H0z", fill: "#ce1126" }), /* @__PURE__ */ React.createElement("path", { d: "M251.264 375l48.738-150 48.738 150-127.6-92.705h157.72M551.264 375l48.738-150 48.738 150-127.6-92.705h157.72", fill: "#007a3d" }));
const ForwardRef = forwardRef(SvgSy);
const Memo = memo(ForwardRef);
export default Memo;
